// extracted by mini-css-extract-plugin
export var capitalize = "CtxDepartementAgencesSection-module--capitalize--c417e";
export var card_buttons_panel = "CtxDepartementAgencesSection-module--card_buttons_panel--2a9d5";
export var card_panel = "CtxDepartementAgencesSection-module--card_panel--5f520";
export var fs14 = "CtxDepartementAgencesSection-module--fs-14--62449";
export var fs16 = "CtxDepartementAgencesSection-module--fs-16--9bbaf";
export var fs20 = "CtxDepartementAgencesSection-module--fs-20--049bf";
export var fs24 = "CtxDepartementAgencesSection-module--fs-24--92d10";
export var fs32 = "CtxDepartementAgencesSection-module--fs-32--040f5";
export var fs40 = "CtxDepartementAgencesSection-module--fs-40--1af67";
export var fsItalic = "CtxDepartementAgencesSection-module--fs-italic--a7fac";
export var fsLg = "CtxDepartementAgencesSection-module--fs-lg--c299b";
export var fsMd = "CtxDepartementAgencesSection-module--fs-md--f1cad";
export var fsNormal = "CtxDepartementAgencesSection-module--fs-normal--6f070";
export var fsSm = "CtxDepartementAgencesSection-module--fs-sm--27603";
export var fsXl = "CtxDepartementAgencesSection-module--fs-xl--4b12b";
export var fsXs = "CtxDepartementAgencesSection-module--fs-xs--3b029";
export var fsXxl = "CtxDepartementAgencesSection-module--fs-xxl--af5b6";
export var fsXxs = "CtxDepartementAgencesSection-module--fs-xxs--a769b";
export var fwBold = "CtxDepartementAgencesSection-module--fw-bold--6f4d6";
export var fwMedium = "CtxDepartementAgencesSection-module--fw-medium--5d04b";
export var fwNormal = "CtxDepartementAgencesSection-module--fw-normal--ba6a7";
export var gotham_bold = "CtxDepartementAgencesSection-module--gotham_bold--6876c";
export var gotham_bold_italic = "CtxDepartementAgencesSection-module--gotham_bold_italic--de632";
export var gotham_book = "CtxDepartementAgencesSection-module--gotham_book--8967f";
export var gotham_book_italic = "CtxDepartementAgencesSection-module--gotham_book_italic--dc8b8";
export var lowercase = "CtxDepartementAgencesSection-module--lowercase--8f7df";
export var map_panel = "CtxDepartementAgencesSection-module--map_panel--451e3";
export var uppercase = "CtxDepartementAgencesSection-module--uppercase--00dbc";